import React from 'react';
import map from "../../assets/images/map.png";
import { useParams } from 'react-router-dom';

function Location() {
  const params = useParams();
  return (
    <div className="h-full w-full">
        <img src={map} alt="Map" className="w-full h-full object-cover" />
    </div>
  )
}

export default Location